export enum NotificationType {
  Silent = 'silent',
  Push = 'push',
  Email = 'email',
  All = 'all',
}
